module.exports = __webpack_public_path__ + "img/shit.0351a03a.png";